<template lang="pug">
.auth-wrapper.auth-v1
  .auth-inner
    v-card.auth-card
      //- logo
      v-card-title.d-flex.align-center.justify-center.py-7
        v-img.me-3(:src="require('@/assets/images/logos/logo.svg')" max-height='30px' max-width='30px' alt='logo' contain='')
        h2.text-2xl.font-weight-semibold
          app-title
      //- title
      v-card-text
        //- p.text-2xl.font-weight-semibold.text--primary.mb-2
        //-   | Carregando...
        p.d-flex.align-center.justify-center
          | Carregando...

        v-progress-linear(
          indeterminate
          rounded
          height="6"
        )

  //- background triangle shape
  img.auth-mask-bg(height='173' :src="require(`@/assets/images/misc/mask-${$vuetify.theme.dark ? 'dark':'light'}.png`)")
  //- tree
  v-img.auth-tree(width='247' height='185' src='@/assets/images/misc/tree.png')
  //- tree
  v-img.auth-tree-3(width='377' height='289' src='@/assets/images/misc/tree-3.png')

</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiFacebook, mdiTwitter, mdiGithub, mdiGoogle, mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { ref } from '@vue/composition-api'
import AppTitle from '@/components/commons/layout/AppTitle'

export default {
  components: {
    AppTitle
  },

  setup() {
    const isPasswordVisible = ref(false)
    const email = ref('')
    const password = ref('')
    const socialLink = [
      {
        icon: mdiFacebook,
        color: '#4267b2',
        colorInDark: '#4267b2',
      },
      {
        icon: mdiTwitter,
        color: '#1da1f2',
        colorInDark: '#1da1f2',
      },
      {
        icon: mdiGithub,
        color: '#272727',
        colorInDark: '#fff',
      },
      {
        icon: mdiGoogle,
        color: '#db4437',
        colorInDark: '#db4437',
      },
    ]

    return {
      isPasswordVisible,
      email,
      password,
      socialLink,

      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
    }
  },
}
</script>

<style lang="scss">
@import '~@/plugins/vuetify/default-preset/preset/pages/auth.scss';
</style>
